<template>
  <div
    class="block-auth-login-magic"
    :class="{
      'is-on-grid': isOnGrid,
    }"
  >
    <div class="block-auth-login-magic__inner">
      <AtomTextHeading
        v-if="title"
        :text="title"
        font-size="h2"
        class="block-auth-login-magic__title"
      />

      <AtomTextRichtext
        v-if="text"
        :html="text"
        class="block-auth-login-magic__text"
      />

      <div class="block-auth-login-magic__form">
        <UtilRendererForm
          v-if="fields?.length > 0"
          :fields="fields"
          :submit-text="submitText"
          :button-alignment="buttonAlignment"
          :success-message="successMessage"
          :use-sentry-error="false"
          :additional-link="link"
          :additional-link-text="linkText"
          :additional-link-tooltip="linkTooltip"
          :error-message="errorMessage"
          :callback="submitCallback"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    /*
        Layout
    */
    isOnGrid: {
        type: Boolean,
        default: false,
    },

    buttonAlignment: {
        type: String,
        default: 'left',
        validator: (value) => ['left', 'center', 'right'].includes(value),
    },

    /*
        Form
    */
    fields: {
        type: Array,
        default: () => [],
    },

    successMessage: {
        type: String,
        default: '',
    },

    errorMessage: {
        type: String,
        default: '',
    },

    submitText: {
        type: String,
        default: '',
    },

    /*
      Content
    */
    title: {
        type: String,
        default: '',
    },

    text: {
        type: String,
        default: '',
    },

    /*
      Additional Link
    */
    link: {
        type: String,
        default: '',
    },

    linkText: {
        type: String,
        default: '',
    },

    linkTooltip: {
        type: String,
        default: '',
    },

    endpoint: {
        type: String,
        default: '/userportal/passwordless/send-link',
    },
});

const {
    endpoint,
} = toRefs(props);

const { locale } = useI18n();
const { public: publicRuntimeConfig } = useRuntimeConfig();
// const receiptDocumentIdCookie = useCookie('receiptDocumentId');
const submitCallback = async (data) => {
    const mappedData = {
        email: data.identifier,
        username: data.identifier,
        agb: data.agb,
        datapolicy: data.datapolicy,
        newsletter: data.newsletter,
        language: locale.value,
        // ...(receiptDocumentIdCookie?.value 
        //     ? { receipt_document_id: receiptDocumentIdCookie.value } 
        //     : {}
        // ),

        context: {
            currentUrl: publicRuntimeConfig.BASE_URL,
        },
    };

    const { error, data: response } = await useFetch(endpoint.value, {
        method: 'post',
        body: mappedData,
    });

    if (error.value) {
        const { statusCode } = error.value;
        if (statusCode !== 400) {
            useSentryError(error.value, {
                useThrow: true,
                payload: mappedData,
                response: response?.value,
            });
        } else {
            throw createError(error.value);
        }
    }
};
</script>

<style lang="scss" scoped>
.block-auth-login-magic {
    @include wrapper-center;

    &.is-on-grid {
        @include wrapper-layout;
        @include grid-layout();
    }
}

.block-auth-login-magic__inner {
    @include box-default;
    @include default-content-columns('medium-narrow');
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    row-gap: 20px;
}

.block-auth-login-magic__text,
.block-auth-login-magic__title {
    width: 100%;
    max-width: 641px;
}
</style>
